import React from "react";
import "./i18n";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import type { Container } from "inversify";

export const mount = (diContainer: Container, parent = document.body) => {
  const container = document.createElement("div");
  container.style.display = "none";
  parent.appendChild(container);
  const root = createRoot(container);
  root.render(<App container={diContainer} />);

  return root;
};
